import React from 'react';
import style from '../css/Policy.module.css';
import { Link } from 'react-router-dom';
import Footer from '../components/Footer';

function Terms() {
	return (
		<div className={style.container}>
			{/* top section */}
			<div className={style.headerBack}>
				<div className={style.btnRow}>
					<Link className={style.btn} to={'/'}>
						Home
					</Link>
					<p>|</p>
					<Link className={style.btn} to={'/terms-and-conditions'}>
						Terms & Conditions
					</Link>
				</div>

				<div className={style.btnRow}>
					<Link className={style.btn} to={'/privacy-policy'}>
						Privacy & Policy
					</Link>
					<p>|</p>
					<Link className={style.btn} to={'/terms-and-conditions'}>
						Terms & Conditions
					</Link>
				</div>
				<h4> Terms & Conditions of HomeTech Repair</h4>
			</div>

			<div className={style.textDiv}>
				<h1>Terms & Conditions of HomeTech Repairs</h1>

				<p>
					Document is revealed in accordance with the provisions of Rule 3(1) of
					the Information Technology (Intermediaries Guidelines) Rules, 2016
					that require publishing the rules and regulations, privacy policy and
					user agreement for access or usage of the www.hometechrepairs.com
					website.
				</p>

				<p>
					The term "HomeTech Repairs" refers to HomeTech Repairs, a statement by
					you that the information in your notice is correct and that you are
					authorized to act on behalf of the relevant business.
				</p>

				<p>
					The term "Platform" refers to the website (www.hometechrepairs.com),
					mobile apps, and any other services offered by HomeTech Repairs.
				</p>

				<p>
					These Terms and Conditions, along with the Terms of Use, Privacy
					Policy, IPR Infringement Policy, and other terms specified, represent
					a legally binding agreement between you and HomeTech Repairs with
					respect to your use of the Platform.
				</p>

				<p>
					All intellectual property relating to this Platform is owned by and
					vests in HomeTech Repairs.
				</p>

				<h2>Service Agreement (DSAR)</h2>
				<p>
					Acceptance of any product under DSAR is at the sole discretion of
					HomeTech Repairs. DSAR offers will be as per the scheme/rate card
					certified by HomeTech Repairs. Costs and terms are subject to change
					without notice. Taxes and duties as applicable shall be additional.
				</p>

				<p>
					The product must be in working condition and certified by HomeTech
					Repairs. In case of defects, the customer must pay for repairs. DSAR
					is not applicable if not renewed consecutively. Service under DSAR
					covers only the listed product and not external accessories or
					connected equipment.
				</p>

				<h2>Disclaimer & Limitation of Liability</h2>
				<p>
					Except as provided under the standard terms of sale, all offerings are
					provided "as is". HomeTech Repairs disclaims all warranties, including
					implied warranties of merchantability, fitness for a particular
					purpose, and non-infringement.
				</p>

				<p>
					HomeTech Repairs is not liable for indirect or consequential damages.
					Total liability will not exceed fees paid by you during the month
					preceding the issue.
				</p>

				<h2>Compliance with Laws</h2>
				<p>
					You agree to comply with all applicable laws regarding your use of
					this Platform.
				</p>

				<h2>Ownership of Information</h2>
				<p>
					You grant HomeTech Repairs exclusive rights to all information
					provided, including media, listings, and user-generated content. We
					may display, use, or repurpose this content as per our policies.
				</p>

				<h2>Termination</h2>
				<p>
					HomeTech Repairs may terminate your account or use of the service at
					its sole discretion without notice.
				</p>

				<h2>Relationship</h2>
				<p>
					There is no agency, partnership, joint venture, or employment
					relationship between HomeTech Repairs and the user.
				</p>

				<h2>False Information</h2>
				<p>
					If false information is found, HomeTech Repairs may terminate your
					account immediately.
				</p>

				<h2>Free Look Period</h2>
				<p>
					You may cancel your campaign within seven working days. Refunds will
					follow the listed terms.
				</p>

				<h2>Refund of Booking Fee</h2>
				<p>
					A booking fee may be collected. Refund decisions rest solely with
					HomeTech Repairs. If you detain any representative, the refund process
					may be canceled.
				</p>

				<h2>Service Availability</h2>
				<p>
					Service hours: 7 AM to 9 PM, excluding National Holidays. Home service
					is available within city limits. Spare parts may involve extra costs,
					and estimates will be shared before proceeding.
				</p>

				<h2>Terms of Use</h2>
				<p>
					By using the Platform, you agree to these terms. You should
					periodically review these terms as we may update them without notice.
				</p>

				<h2>Newsletter Subscriptions</h2>
				<p>
					Visitors may subscribe to newsletters. Subscriptions are confirmed by
					email.
				</p>

				<h2>Password Management</h2>
				<p>
					You are responsible for securing your password and should not share
					it.
				</p>

				<h2>Managing Account Info</h2>
				<p>
					You may edit or delete your info via account settings or by emailing
					help@hometechrepairs.com.
				</p>

				<h2>Communications</h2>
				<p>
					By providing your number, you consent to receive calls/SMS, even if
					registered with DND. Calls may be recorded for quality assurance.
				</p>

				<h2>Content Policy</h2>
				<p>
					All content is protected. Downloading or modifying content is
					unauthorized without written permission.
				</p>

				<h2>Visitor Responsibility</h2>
				<p>
					You are responsible for protecting yourself from potential threats
					online. If any objectionable content is found, report it to
					help@hometechrepairs.com.
				</p>

				<h2>Disclaimer of Warranties</h2>
				<p>
					This Platform is provided "as is". HomeTech Repairs disclaims all
					warranties unless explicitly stated otherwise.
				</p>

				<h2>Termination & Additional Notices</h2>
				<p>
					HomeTech Repairs reserves the right to discontinue services without
					prior notice.
				</p>

				<h2>Customer Care</h2>
				<p>
					By using this Platform, you acknowledge and accept all terms. Contact
					us for any concerns regarding your experience.
				</p>
			</div>

			<Footer />
		</div>
	);
}

export default Terms;
